import api from '../../service/api';
import routes from "../../service/apiRoutes";

export const changePassword = (data) => api.post(routes.changePassword, data, {noauth: true});
